// eslint-disable-next-line no-restricted-imports
import type { PossibleTypesMap } from "@apollo/client";

import type Applications from "constants/applications";
import { APPLICATION_CONFIGURATION_KEY } from "@entries/constants";

import { sandboxEnabled } from "./sandbox";

type Configuration = {
  // `environmentName` is specically not named to discourage its use. Do **not** write conditionals with it.
  sentryDSN?: string;
  sentryReplaySampleRate?: number;
  sumoLogEndpoint?: string;
  easyLinkApiKey?: string;
  personaEnvironment?: "production";
  portalName: (typeof Applications)[keyof typeof Applications];
  apiHost: string;
  socketHost: string;
  testTransactionApiHost: string;
  marketingHost: string;
  releaseName: string;
  mobileAppDownloadUrl: string;
  googleSignInAppHost: string;
  hasHacksEnabled: boolean;
  isCustomerFacingTestEnvironment: boolean;
  hasTestingEnvironmentWarning: boolean;
  branchApiKey: string;
  androidBranchUrl: string;
  connectToStripeClientId: string;
  paymentStripeApiKey: string;
  plaidEnvironment: "production" | "sandbox";
  plaidApiKey: string;
  zendeskChatApiKey: string;
  hostName: string;
  isTestMarketingEnvironment: boolean;
  googleMapsApiKey: string;
  launchDarklyApiKey: string;
  launchDarklyNotaryApiKey: string;
  launchDarklySignerApiKey: string;
  launchDarklyAdminApiKey: string;
  graphQLSchema: {
    introspectionDataEndpoint: string;
    possibleTypes: PossibleTypesMap;
    denormalizedTypeNames: string[];
    /** Enum name mapped to object of all variants */
    runtimeGraphQLEnums: Record<string, Record<string, string>>;
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const buildConfiguration = window[APPLICATION_CONFIGURATION_KEY as any] as unknown as
  | (Configuration & {
      apiHostProof: string;
      testTransactionApiHostProof: string;
      hostNameProof: string;
      socketHostProof: string;
      marketingHostProof: string;
    })
  | undefined;

if (!buildConfiguration) {
  throw new Error("App not configured, cannot run");
}

const isSandbox = sandboxEnabled();
const isProof = window.location.origin.endsWith("proof.com");
const config: Configuration = {
  ...buildConfiguration,
  apiHost:
    isSandbox && isProof
      ? buildConfiguration.testTransactionApiHostProof
      : isProof
      ? buildConfiguration.apiHostProof
      : isSandbox
      ? buildConfiguration.testTransactionApiHost
      : buildConfiguration.apiHost,
  hostName: isProof ? buildConfiguration.hostNameProof : buildConfiguration.hostName,
  socketHost: isProof ? buildConfiguration.socketHostProof : buildConfiguration.socketHost,
  marketingHost: isProof ? buildConfiguration.marketingHostProof : buildConfiguration.marketingHost,
};

export default config;
